import NetInfo, { NetInfoState } from '@react-native-community/netinfo';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import connectionComponent, { validateConnectionChange } from './connectivityUtils';

function ConnectivityListener() {
  const [showNoConnection, setShowNoConnection] = useState<boolean>(false);
  const [connectionState, setConnectionState] = useState<NetInfoState | null>(null);

  const { t } = useTranslation('common');

  const handleNetworkStateChanged = useCallback(
    validateConnectionChange(connectionState, setConnectionState, setShowNoConnection),
    [connectionState],
  );

  useEffect(() => {
    const fetchInitialNetworkState = async () => {
      const initialNetworkState = await NetInfo.fetch();
      setConnectionState(initialNetworkState);
    };

    fetchInitialNetworkState();

    const unsubscribe = NetInfo.addEventListener(handleNetworkStateChanged);

    return () => unsubscribe();
  }, [handleNetworkStateChanged]);

  return connectionComponent(showNoConnection, t);
}

export default ConnectivityListener;
